let cached: boolean | null = null;

/**
 * Whether this browser can actually give us a WebGL context.
 *
 * Blocked or unavailable WebGL (old hardware, GPU blocklists, headless Chrome without
 * a GPU, privacy extensions) makes the R3F canvas throw during render. Detecting it up
 * front lets the sections fall back to their static art instead of logging an uncaught
 * exception and leaving an empty box.
 */
export function supportsWebGl(): boolean {
  if (cached !== null) {
    return cached;
  }
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    cached = false;
    return cached;
  }

  try {
    const canvas = document.createElement('canvas');
    cached = Boolean(
      window.WebGLRenderingContext &&
        (canvas.getContext('webgl2') || canvas.getContext('webgl')),
    );
  } catch {
    cached = false;
  }

  return cached;
}
